import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { setStatic, withHandlers, compose } from 'recompose';
import { Checkbox } from '@ontruck/orc';
import { StyledFilter } from './styled';

const enhance = compose(
  setStatic('filterName', 'CancelledFilter'),
  withHandlers({
    handleChange:
      ({ onChange }) =>
      (e, { value }) => {
        if (!onChange) {
          return;
        }
        onChange(value);
      },
  })
);

const StyledFilterColor = styled(StyledFilter)`
  color: var(--primary-top-bar-color);
`;

const CancelledFilter = ({ intl, value, handleChange, stylingProps }) => {
  const t = intl.messages.components.ShipmentFilters;
  return (
    <StyledFilterColor {...stylingProps}>
      <Checkbox label={t.cancelled_filter} size="M" checked={value} onChange={handleChange} />
    </StyledFilterColor>
  );
};

CancelledFilter.propTypes = {
  handleChange: PropTypes.func,
  value: PropTypes.any,
  intl: PropTypes.any,
  stylingProps: PropTypes.object.isRequired,
};

export default enhance(CancelledFilter);
